module.exports = __webpack_public_path__ + "static/media/6.90c73940.jpg";